import api from ".";
import { IUserCreds } from "../types/auth";
export const signIn = async (data:IUserCreds) => {
    const { username, password } = data;
    const url = `admins/sign-in?username=${username}&password=${password}`;

    try {
        const response = await api.get(url);
        return response;
    } catch (error) {
        throw error;
    }
};